<template>
	<div class="w-100">
		<div id="hotel-home-page" class="d-block"></div>
		<Mobile 
			v-if="is_mobile_view"
			:data_parent="data_to_child"
			@shareClick="shareClick"
			@detailModuleClick="goToDetailModule"
			@callClick="callBtnClick"
			@goToDetailSlider="goToDetailSlider"
			@checkReservationStatus="loadDetailReservation"
			>
		</Mobile>
		<Desktop 
			v-else
			:data_parent="data_to_child"
			@shareClick="shareClick"
			@detailModuleClick="goToDetailModule"
			@callClick="callBtnClick"
			@goToDetailSlider="goToDetailSlider"
			@checkReservationStatus="loadDetailReservation"
			>
		</Desktop>
	</div>
</template>
<script>
	import Desktop from '@/pages/hotel/HotelHomePageDesktop';
	import Mobile from '@/pages/hotel/HotelHomePageMobile';
  import {mapGetters,mapMutations,mapActions} from 'vuex';
  import {get,post} from '@/services/index.js'
  import moment from 'moment'


	export default{
		components:{
			Desktop,
			Mobile
		},
		data(){
			return{
				is_load: false,
				error: {
					menu: '',
					lowest_price: '',
				},
				module_services: {
					menu: [],
					preview: []
				},
				loading_section:{
					top: true,
					reservation: true,
					room_type: true,
					small_menu: true,
					big_menu: true,
					promo: true,
					be: true,
					bottom: true
				},
				lowest_price: 0,
				promo: false,
				reservation: {},
				reservation_load: false,
				concierge_status: '',
				room_type: [],
				gmap_option: {
					mapTypeControl: false,
          streetViewControl: false,
          panControl: false,
          rotateControl: false,
          scaleControl: false,
          gestureHandling: 'none'
				}
			}
		},
		computed:{
			...mapGetters(['getMerchant','getBePrice','getCurrentLanguage','getRoomStay','getConciergeAuth','isNotLogin','getIsConciergeAuthWithoutPinToken','getMerchantLoad','isReservationActive','getReservationActive','isLoggedIn','getCurrentUser']),
			is_mobile_view(){
				return window.innerWidth > 768 ? false : true
			},
			data_to_child(){
				return {
					error: this.error,
					menu: this.module_services.menu,
					preview: this.module_services.preview,
					lowest_price: this.lowest_price,
					promo: this.promo,
					reservation: this.reservation,
					reservation_load: this.loading_section.reservation,
					concierge_status: this.concierge_status,
					room_type: this.room_type,
					loading_section: this.loading_section,
					gmap_option: this.gmap_option
				}
			}
		},
		watch:{
			is_mobile_view(){
				document.getElementById('hotel-home-page').scrollIntoView({
	        behavior: 'smooth'
	      });
	      this.is_load = true
	      setTimeout(()=>{
	      	this.is_load = false
	      },1000)
			},
			getMerchantLoad(){
				if(!this.getMerchantLoad){
					this.loadFirstData()
				}
			}
		},
		mounted(){
			document.getElementById('hotel-home-page').scrollIntoView({
        behavior: 'smooth'
      });
			this.logFirstLoad()
      this.resetConciergeOrder()
		},
		methods:{
      ...mapMutations(['resetConciergeOrder','resetConciergeAuth','setConciergeAuth','setConciergeReservation','setReservationActive']), 
      ...mapActions(['setToken','setUser','logout']),
      logFirstLoad(){
      	let event = Object.keys(this.getRoomStay).length == 0 ? 'Page load direct' : 'Page load from qrcode'
      	this.$postLog("HOME","HOMEPAGE",event)
      },
      callBtnClick(){
      	this.$postLog('HOME','NAVBAR','Clicked menu call')
      	setTimeout(()=>{
      		let tag_a = document.createElement('a')
      		tag_a.href = `tel:${this.getMerchant.phone}`
      		tag_a.click()
      		tag_a.remove()
      	},300)
      },
      shareClick(){
      	 this.$postLog('HOME','NAVBAR','Clicked menu share')
        var value = window.location.href;
        var input_temp = document.createElement("input");
        input_temp.value = value;
        document.body.appendChild(input_temp);
        input_temp.select();
        document.execCommand("copy");
        document.body.removeChild(input_temp);
        this.$notify({
				  title: 'Share',
				  type: 'success',
				  position: 'top left',
				  text: 'Successfully copy the url'
				});
      },
      goToDetailModule(code){
      	let url_detail = ''
      	if(code == 'concierge-room-dining'){
      		url_detail = 'room-dining'
      	}else if(code == 'concierge-laundry'){
      		url_detail = 'laundry'
      	}else if(code == 'concierge-spa'){
      		url_detail = 'spa'
      	}else if(code == 'concierge-experience'){
      		url_detail = 'experience'
      	}
      	this.$postLog('HOME','MODULE MENU',`Clicked menu ${code}`)

				let not_custom_pos = ['concierge-room-dining','concierge-laundry','concierge-spa','concierge-experience']
				let is_code_not_custom_pos = not_custom_pos.some(x=>x == code)
				if(is_code_not_custom_pos){
					this.$router.push(`/${this.getMerchant.code}/concierge/${url_detail}`)
				}else{
					this.$router.push(`/${this.getMerchant.code}/order/${code}`)
				}
      },
      goToDetailSlider(slider){
      	if(slider.use_redirect_button){
      		this.$postLog('HOME','SLIDER','Clicked promotion slider')
      		if(slider.button_url_type == 'CUSTOM_URL'){
      			setTimeout(()=>{
		      		let tag_a = document.createElement('a')
		      		tag_a.href = slider.button_url
		      		tag_a.target = '_blank'
		      		tag_a.click()
		      		tag_a.remove()
		      	},300)
      		}else{
      			this.$router.push(`/${this.getMerchant.code}/${slider.button_url}`)
      		}
      	}
      },
      loadFirstData(){
      	this.is_load = true
				setTimeout(()=>{
					this.loading_section.top = false
				},1000)
				
				let func_exe = [
					this.loadMenu('BASE_HOME_BOOK_SERVICE'),
					this.loadPromoList(),
    			this.loadMenu('BASE_HOME'),
				]

				if(this.isReservationActive){
					func_exe.unshift(this.loadDetailReservation())
				}else{
					this.loading_section.reservation = false
				}
				
				if(this.getMerchant.use_booking_engine){
					func_exe.splice(1, 0, this.loadRoomType())
					func_exe.splice(4, 0, this.loadBookingEngineData())
				}else{
					this.loading_section.room_type = false
					this.loading_section.be = false
				}

      	Promise.all(func_exe).then(()=>{
					this.loading_section.bottom = false
					this.is_load = false
				})
      },
			loadMenu(page_type){
				return new Promise(done=>{
					
					if(page_type == 'BASE_HOME_BOOK_SERVICE') this.loading_section.small_menu = true
					else this.loading_section.big_menu = true
					
	        get("CORE_HOTEL","merchant-service",{
	          merchant_id: this.getMerchant.id,
	          page_type: page_type
	        }).then(response=>{
	          let res = response.data
	          if(res.success){
	          	if(page_type == 'BASE_HOME'){
	          		this.module_services.preview = res.data 
	          	}else{
	          		this.module_services.menu = res.data 
	          	}
	          }else{
	            this.error.menu = res.message
	          }
						
						if(page_type == 'BASE_HOME_BOOK_SERVICE') this.loading_section.small_menu = false
						else this.loading_section.big_menu = false
						
	          done()
	        })
				})
      },
      loadBookingEngineData() {
      	return new Promise(done=>{
					this.loading_section.be = true
      		let check_in = new Date()
	        let check_out = moment(check_in).add(this.$defaultFilterBE('night'),'d').toDate()
	        let params = {
	          merchant_id: this.getMerchant.id,
	          check_in_date: moment(check_in).format("YYYY-MM-DD"),
	          check_out_date: moment(check_out).format("YYYY-MM-DD"),
	          adult: this.$defaultFilterBE('adult'),
	          child: 0,
	          infant: 0,
	          sort_by: 'room_type',
	          min_price: this.getBePrice[0],
	          max_price: this.getBePrice[1],
	          filter_by: 'price',
	          language_code: this.getCurrentLanguage,
          	use_promotion_combine:true
	        }
	        get("CORE_HOTEL", "search-room",
	          params
	        ).then(response => {
	          let res = response.data
	          let lowest = 0 
	          if (res.success) {
			        for(let i=0;i<res.data.length;i++){
			          let final_price = res.data[i].best_price.final_price
			          if(i==0){
			            lowest = final_price
			          }
			          if(lowest>final_price){
			            lowest = final_price
			          }
			        }
			        this.lowest_price = lowest
	          }else{
	            this.error.lowest_price = res.message
	          }
						this.loading_section.be = false
	          done()
	        })
      	})
      },
      loadPromoList(){
				return new Promise((success,fail)=>{
					this.loading_section.promo = true
					get("CONCIERGE","promo-code-option",{
						merchant_id: this.getMerchant.id
					}).then(response=>{
						let res = response.data
						if(res.success){
							this.promo = res.data
							this.loading_section.promo = false
							success()
						}else{
							this.loading_section.promo = false
							fail(res.message)
						}
					})
				})
			},
			loadRoomType(){
				return new Promise((success,fail)=>{
					this.loading_section.room_type = true
					let date = {
						check_in: moment().toDate(),
						check_out: moment(moment().toDate()).add(this.$defaultFilterBE('night'),'d').toDate()
					}
					let params = {
						merchant_id: this.getMerchant.id,
						adult: this.$defaultFilterBE('adult'),
						child: 0,
						infant: 0,
						check_in_date:this.$customFormatDateTime(date.check_in,'null','YYYY-MM-DD'),
						check_out_date:this.$customFormatDateTime(date.check_out,'null','YYYY-MM-DD'),
						use_promotion_combine:true
					}
					
					get("CORE_HOTEL",`room-type-list?${this.$convertObjectToStringParams(params)}`).then(response=>{
						if (response.data.success) {
							this.room_type = response.data.data
							this.loading_section.room_type = false
							success()
						}else{
							this.loading_section.room_type = false
							fail(response.data.message)
						}
					})
				})
			},
			loadDetailReservation(){
				return new Promise((success,fail)=>{
					this.loading_section.reservation = true
          get("CONCIERGE",`reservation/${this.getReservationActive.detail_id}`,{
            merchant_id: this.getMerchant.id
          }).then(response=>{
						let res = response.data
            if(res.success){
							let resv = res.data
							if(this.$isReservationValid(resv)){
								this.reservation = resv
								if(!this.$isNotEmpty(resv.room_type)){
									this.reservation.room_type = {}
									this.reservation.room_type.name = 'Unallocated Room Type'
								}
								if(!this.$isNotEmpty(resv.room)){
									this.reservation.room = {}
									this.reservation.room.name = 'Unallocated'
								}
								this.loading_section.reservation = false
								success()
							} else{
								this.setReservationActive('reset')
								this.loading_section.reservation = false
								success()
							}
            }else{
							this.loading_section.reservation = false
              fail(res.message)
            }
          })
        })
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/hotel/HotelHomePage.vue